import React,{useEffect} from 'react';
import styled from '@emotion/styled';
import { useSettingModal } from '../../../../hooks/Context';

const Container  = styled.div`
    width:500px;
    background-color: #fff;
    display:flex;
    justify-content:center;
    align-items: center;
    height: 100px;
    border-radius: 10px;
` 

const Waiting = ({message}:any) => {
    const {setShowCancel} = useSettingModal();
   
  return (
    <Container>
       {message? message :'Please wait ...'} 
    </Container>
  )
}

export default Waiting